<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ks0XgA/tc-custom/9781426876493.jpg?1718106101347" alt="This image is the cover for the book Dr. Zinetti's Snowkissed Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dr. Zinetti's Snowkissed Bride
      </h1>
      <p class="bookDescription body article font2">
        <b>A playboy doctor falls for an insecure single mother in this feel-good Christmas romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>There’s not enough mistletoe in the world to tempt rescue medic Meg Miller to get anywhere near notorious heartbreaker Dr. Dino Zinetti! Though her small son thinks the man’s a superhero, Meg knows the truth—the incredibly sophisticated doctor would never look twice at a scruffy tomboy more comfortable up a mountain than in a dress.<br/><br/>But Meg has gotten under the normally unflappable Dino’s skin, and he’s not about to give up on her—however hard she fights their explosive attraction. This Christmas he’ll teach Meg the meaning of romance . . . and receive a crash course in love himself.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Morgan
      </h2>
      
      <p class="authorDescription body article">Sarah Morgan is a USA Today and Sunday Times bestselling author of contemporary romance and women&#39;s fiction. She has sold more than 21 million copies of her books and her trademark humour and warmth have gained her fans across the globe. Sarah lives with her family near London, England, where the rain frequently keeps her trapped in her office. Visit her at www.sarahmorgan.com&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?81fbb9c0